module.exports = __webpack_public_path__ + "static/img/UOOYA_BOOL-7.5d07c82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/04/UOOYA_BOOL-7.jpg
// module id = qZqJ
// module chunks = 7